import axios from 'axios';

export const request = axios.create({
  baseURL: process.env.TRACKING_BFF_HOST,
  ...(process.env.TRACKING_BFF_KEY && {
    headers: { 'api-key': process.env.TRACKING_BFF_KEY },
  }),
  timeout: process.env.TRACKING_BFF_TIMEOUT ? Number(process.env.TRACKING_BFF_TIMEOUT) : 60000,
});
